import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";
import "react-toastify/dist/ReactToastify.css";

import "./App.css";
import Sidebar from "./components/molecular/Sidebar";
import AppRoutes from "./routes/AppRoutes";

function App() {
  const { isAuthenticated } = useSelector((state) => state.login);

  return (
    <>
      <div className="App min-h-screen w-full flex ">
        <Router>
          {isAuthenticated && (
            <>
              <Sidebar />
              <div className="w-72  min-h-screen bg-gray-100" />
            </>
          )}
          <AppRoutes />
        </Router>
      </div>
      <ToastContainer
        position="top-center"
        autoClose={1500}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}

export default App;
